const IMAGE_FILE_EXTENSIONS = [
	"jpg",
	"jpeg",
	"png",
	"gif",
	"tiff",
	"bmp",
	"webp",
	"svg",
	"heif",
];

const VIDEO_FILE_EXTENSIONS = [
	"mp4",
	"mov",
	"avi",
	"wmv",
	"mkv",
	"flv",
	"webm",
];

enum BULK_IMPORT_TEMPLATE {
	PRODUCTS,
	PRODUCT_TYPES,
	PRODUCT_CATEGORIES,
	PRODUCT_OPTIONS,
	PRODUCT_OPTION_GROUPS,
	AGENTS,
	CLIENTS,
}

const DEFAULT_CURRENCY_CODE = "USD";

export {
	IMAGE_FILE_EXTENSIONS,
	VIDEO_FILE_EXTENSIONS,
	BULK_IMPORT_TEMPLATE,
	DEFAULT_CURRENCY_CODE,
};
